import React from 'react';
import Title from '../Title';
import Text from '../Text';
import './Summary.less';
import { SummeryType } from '../../types';

export type SummaryProps = {
  result?: string | number;
  label?: string;
  icon?: string;
  size?: SummeryType;
  onClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onHover?: boolean;
};

const TSummary: React.FC<SummaryProps> = ({
  result,
  label,
  icon,
  size = 'medium',
  onHover,
}) => {
  const classNames = `t-summary-${size}`;
  const summerySize = {
    large: 3,
    medium: 3,
    small: 4,
    extraSmall: 4,
  };

  const cardHover = ['t-summary'];
  if (onHover) {
    cardHover.push('cardHover');
  }

  return (
    <div className={cardHover.join(' ')}>
      <div>
        <Title level={summerySize[size]} bold>
          {result}
        </Title>
        <Text rows={1} level={summerySize[size]}>
          {label}
        </Text>
      </div>
      <div>
        <img className={classNames} src={`${icon}`} />
      </div>
    </div>
  );
};

export default TSummary;
